var _style, _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chat-2_svg__Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 390.91 215.31",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".chat-2_svg__st4{opacity:.5}.chat-2_svg__st6{fill:#ff7080}.chat-2_svg__st8{fill:#fff}.chat-2_svg__st9{fill:#664f26}.chat-2_svg__st10{fill:#12120d}.chat-2_svg__st16{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.35 88.55V20.86c0-9.75-7.9-17.66-17.65-17.68H21.39C11.63 3.17 3.71 11.07 3.7 20.83v173.85c-.01 9.75 7.9 17.66 17.65 17.67H287.7c9.77-.01 17.68-7.93 17.67-17.7v-63.61l78.26-17.48-78.28-25.01z",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305.35 88.55V20.86c0-9.75-7.9-17.66-17.65-17.68H21.39C11.63 3.17 3.71 11.07 3.7 20.83v173.85c-.01 9.75 7.9 17.66 17.65 17.67H287.7c9.77-.01 17.68-7.93 17.67-17.7v-63.61l78.26-17.48-78.28-25.01z",
    fill: "none",
    stroke: "#ff0001",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M220.26 96.13c0-41.74-29.46-61.38-61.38-61.38S97.5 54.39 97.5 96.13c-8.51 0-12.27 6.13-12.27 12.27s3.75 12.27 12.27 12.27c0 16.37 17.19 39.28 61.38 39.28s61.38-22.91 61.38-39.28c8.52 0 12.27-6.13 12.27-12.27s-3.75-12.27-12.27-12.27",
    fill: "#ffde66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.34 66.67c-9.82-7.37-4.91-17.19-4.91-17.19s19.63 12.28 36.82 7.36c0 0-9.82-2.45-12.27-9.82 0 0 9.82 2.46 17.18 0-9.82-7.36-22.1-12.27-39.24-12.27s-29.5 4.91-39.32 12.27c9.82 12.28 19.64 19.62 41.74 19.65",
    fill: "#ffb200"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "chat-2_svg__st4"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "chat-2_svg__SVGID_1_",
    d: "M160.06 91.31h86.02v47.23h-86.02z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "chat-2_svg__SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chat-2_svg__SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chat-2_svg__SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "chat-2_svg__st6",
    d: "M217.7 121.61c-.88-5.91-8.14-9.47-16.23-7.95s-13.93 7.54-13.06 13.45c.87 5.91 8.14 9.47 16.24 7.95s13.92-7.54 13-13.45"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "chat-2_svg__st4"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "chat-2_svg__SVGID_3_",
    d: "M71.68 91.32h86.02v47.23H71.68z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "chat-2_svg__SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chat-2_svg__SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chat-2_svg__SVGID_4_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "chat-2_svg__st6",
    d: "M116.27 113.66c-8.07-1.51-15.35 2-16.22 7.95s5 11.92 13.06 13.45 15.35-2.05 16.22-7.95c.87-5.9-5-11.93-13.06-13.45"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "chat-2_svg__st8",
    d: "M144.15 97.36c0 8.84-7.16 16-16 16s-16-7.16-16-16 7.16-16 16-16c8.81-.03 15.97 7.09 16 15.9v.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "chat-2_svg__st9",
    d: "M128.19 86.31c6.08 0 11 4.92 11 11s-4.92 11-11 11-11-4.92-11-11 4.92-11 11-11"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "chat-2_svg__st10",
    d: "M131.88 97.36c0 2.04-1.65 3.69-3.69 3.69s-3.69-1.65-3.69-3.69 1.65-3.69 3.69-3.69h.01c2.03 0 3.68 1.65 3.68 3.68v.01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "chat-2_svg__st8",
    d: "M205.53 97.36c0 8.84-7.16 16-16 16s-16-7.16-16-16 7.16-16 16-16 16 7.16 16 16"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "chat-2_svg__st9",
    d: "M189.57 86.31c6.08 0 11 4.92 11 11s-4.92 11-11 11-11-4.92-11-11 4.92-11 11-11"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "chat-2_svg__st10",
    d: "M189.57 93.68c2.03 0 3.68 1.65 3.68 3.68s-1.65 3.68-3.68 3.68c-2.03 0-3.68-1.65-3.68-3.68 0-2.04 1.65-3.68 3.68-3.68"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M195.7 137.28c0 20.54-16.48 30-36.82 30s-36.82-9.5-36.82-30 16.58-11.7 36.92-11.7 36.72-8.82 36.72 11.7",
    fill: "#61c2ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.88 132.98c8.13 0 14.73 5.49 14.73 12.27s-6.6 12.28-14.73 12.28-14.73-5.5-14.73-12.28 6.55-12.27 14.73-12.27",
    fill: "#6136a8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M158.88 173.14c-10.6 0-20.4-7.1-20.4-17.45s9.8-7.83 20.4-7.83 20.41-2.52 20.41 7.83-9.8 17.45-20.41 17.45m0-30.31c-14.92 0-27-1.7-27 12.86s12.08 26.36 27 26.36 27-11.8 27-26.36-12.1-12.86-27-12.86",
    fill: "#fabf66"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.7 149.76a2.758 2.758 0 01-2.68 2.83H151.7a2.758 2.758 0 01-2.68-2.83v-6.61a2.758 2.758 0 012.68-2.83h14.28c1.52.04 2.72 1.31 2.68 2.83l.04 6.61z",
    fill: "#42ade3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M158.88 123.13c-10.26 0-15.39-7.36-10.26-7.36h20.52c5.14 0 0 7.35-10.26 7.36",
    fill: "#eba352"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "chat-2_svg__st16",
    d: "M-1516.88 214.19H398.28v-560.23"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "chat-2_svg__st16",
    d: "M-1516.88 214.19H398.28v-560.23"
  })));
}
export default __webpack_public_path__ + "dad8ff1082eff69f62b3404b5c95aacb.svg";
export { SvgChat2 as ReactComponent };